module.exports = __webpack_public_path__ + "img/img-archive-bg01-m.ae86f2ce.png";